import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Plus = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      viewBox="0 0 6 6"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path d="M3.75 0L2.25 0 2.25 2.25 0 2.25 0 3.75 2.25 3.75 2.25 6 3.75 6 3.75 3.75 6 3.75 6 2.25 3.75 2.25z" />
    </svg>
  );
};

Plus.displayName = 'Plus';
